
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/all-games",
      function () {
        return require("private-next-pages/all-games.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/all-games"])
      });
    }
  